module.exports = __webpack_public_path__ + "static/media/IFEC.2855c786.jpg";